import i18n from '@/settings/i18n';
import CountryList from './CountryList';

const t = i18n.init('shared');

const CountrySelectorPanel = ({ onClose }: { onClose: () => void }) => (
  <section className="pt-2">
    <h2 className="flex h-10 items-center p-5 text-base font-bold">
      {t`Choose your country`}
    </h2>
    <div className="px-2">
      <CountryList onClose={onClose} />
    </div>
  </section>
);

export default CountrySelectorPanel;
